// med rep search

function toggleDropdown() {
  const dropdownItems = document.getElementById("dropdownItems");
  dropdownItems.style.display =
    dropdownItems.style.display === "block" ? "none" : "block";
}

document
  .getElementById("dropdownSearch")
  .addEventListener("input", function () {
    const filter = this.value.toUpperCase();
    const items = document.getElementsByClassName("dropdown-item");

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const txtValue = item.textContent || item.innerText;
      item.style.display = txtValue.toUpperCase().includes(filter)
        ? ""
        : "none";
    }

    const arrow = document.getElementById("arrowDown");
    if (this.value.trim() !== "") {
      arrow.style.display = "none";
    } else {
      arrow.style.display = "inline";
    }
  });

document.addEventListener("click", function (event) {
  const dropdown = document.querySelector(".dropdown");
  if (!dropdown.contains(event.target)) {
    document.getElementById("dropdownItems").style.display = "none";
  }
});

document
  .getElementById("dropdownItems")
  .addEventListener("click", function (event) {
    event.stopPropagation();
  });

function selectItem(value) {
  const dropdownButton = document.querySelector(".dropdown-button");
  dropdownButton.textContent = value + " ";
  document.getElementById("dropdownItems").style.display = "none";

  if ($(".error-note").length == 0) {
    $(".med-note").css("display", "none");
    $("#checkout-button").removeAttr("disabled");
  }

  const e = new Event("change");
  document.getElementById("dropdown-cart").dispatchEvent(e);
}

// med rep search modal

function toggleDropdownModal() {
  const dropdownItems = document.getElementById("dropdownItems-modal");
  dropdownItems.style.display =
    dropdownItems.style.display === "block" ? "none" : "block";
}

document
  .getElementById("dropdownSearch-modal")
  .addEventListener("input", function () {
    const filter = this.value.toUpperCase();
    const items = document.getElementsByClassName("dropdown-item-modal");

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const txtValue = item.textContent || item.innerText;
      item.style.display = txtValue.toUpperCase().includes(filter)
        ? ""
        : "none";
    }

    const arrow = document.getElementById("arrowDown-modal");
    if (this.value.trim() !== "") {
      arrow.style.display = "none";
    } else {
      arrow.style.display = "inline";
    }
  });

document.addEventListener("click", function (event) {
  const dropdown = document.querySelector(".dropdown-modal");
  if (!dropdown.contains(event.target)) {
    document.getElementById("dropdownItems-modal").style.display = "none";
  }
});

document
  .getElementById("dropdownItems-modal")
  .addEventListener("click", function (event) {
    event.stopPropagation();
  });

function selectItemModal(value) {
  if ($(".note-error").text().trim() === "") {
    if (value != "") {
      $(".med-note-modal").css("display", "none");
      $(".continue-checkout").removeAttr("disabled");
    }
  }

  const dropdownButton = document.querySelector(".dropdown-button-modal");
  dropdownButton.textContent = value + " ";
  document.getElementById("dropdownItems-modal").style.display = "none";
}

$(document).ready(function () {
  // $(document).on('blur', '#dropdown-cart', function(e){
  //     if(e.target.innerText.trim() === 'Select Medical Representative'){
  //       $('#checkout-button').attr('disabled', 'disabled');
  //     }
  //    else{
  //      if($('.error-note').length > 0){
  //        $('#checkout-button').attr('disabled', 'disabled');
  //      }
  //      else{
  //        $('.med-note').css('display', 'none');
  //        $('#checkout-button').removeAttr('disabled');
  //      }
  //    }
  //  });

  $("#CartDrawer-Note").val("");

  // if (!window.location.pathname.includes("collections/all")) {
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(0)
  //     .css("display", "none");
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(0)
  //     .removeAttr("open");
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(1)
  //     .attr("open", true);
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(1)
  //     .find("summary")
  //     .attr("aria-expanded", "true");
  // }

  //collection
  $(document).on("click", ".shopify-buy-it-now", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "visible")
      .css("opacity", "1");
    $("body").addClass("modal-open"); // Disable scroll
    $("#variant_id").val($(this).data("key"));
    $("#product_quantity").val(e.target.form[4].value);
    $("#CartDrawer-Note-modal").val("");

    var amount = $(this).data("a");

    if ($("." + $(this).data("key") + "> .axt_discounted_price").length) {
      var temp = $("." + $(this).data("key") + "> .axt_discounted_price")
        .text()
        .replace(/[^0-9.-]+/g, "");
      var amount = parseFloat(temp).toFixed(2);
    }

    if ($(this).data("p") != "" && $(this).data("p") != 0.0) {
      if (amount * $("#product_quantity").val() > $(this).data("p")) {
        $(".note-error").text("You exceeded your purchase limit.");
        $(".note-error").removeAttr("hidden");
      } else {
        $(".med-note-modal").css('display', 'unset');
        $(".continue-checkout").attr("disabled", "disabled");
        $(".note-error").attr("hidden", "true");
      }
      if (
        $("#dropdownBtn-modal").text().trim() ===
        "Select Medical Representative"
      ) {
        $(".continue-checkout").attr("disabled", "disabled");
      }
    } else {
      $(".note-error").text("Please login first to transact.");
      $(".note-error").removeAttr("hidden");
      $(".continue-checkout").attr("disabled", "disabled");
    }
  });

  //product page
  $(document).on("click", ".shopify-buy-it-now-product", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "visible")
      .css("opacity", "1");
    $("body").addClass("modal-open"); // Disable scroll
    $("#variant_id").val($(this).data("key"));
    $("#product_quantity").val(e.target.form[1].value);
    $("#CartDrawer-Note-modal").val("");

    var amount = $(this).data("a");

    if ($("." + $(this).data("key") + "> .axt_discounted_price").length) {
      var temp = $("." + $(this).data("key") + "> .axt_discounted_price")
        .text()
        .replace(/[^0-9.-]+/g, "");
      var amount = parseFloat(temp).toFixed(2);
    }

    if ($(this).data("p") != "" && $(this).data("p") != 0.0) {
      if (amount * $("#product_quantity").val() > $(this).data("p")) {
        $(".note-error").text("You exceeded your purchase limit.");
        $(".note-error").removeAttr("hidden");
        $(".continue-checkout").attr("disabled", "disabled");
      } else {
        $(".note-error").attr("hidden", "hidden");
        $(".med-note-modal").css('display', 'unset');
        $(".continue-checkout").attr("disabled", "disabled");
      }
    } else {
      $(".note-error").text("Please login first to transact.");
      $(".note-error").removeAttr("hidden");
      $(".continue-checkout").attr("disabled", "disabled");
    }
  });

  $(document).on("click", ".continue-checkout", function (e) {
    $(".continue-checkout").addClass("loading");
    var medrepModal = $.trim($("#dropdownBtn-modal").text());
    var buyitnow_details = {
      id: $("#variant_id").val(),
      quantity: $("#product_quantity").val(),
    };

    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      success: function () {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(buyitnow_details),
        })
          .then((response) => response.json())
          .then((cart) => {
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                var updateData = {
                  note:
                    "Medical Representative: \r\n" +
                    medrepModal +
                    "\r\n\r\nInstruction: \r\n" +
                    document.getElementById("CartDrawer-Note-modal").value,
                  updates: {},
                };

                // Update cart with note
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify(updateData),
                })
                  .then((response) => response.json())
                  .then((cart) => {
                    window.location.href = "/checkout";
                  })
                  .catch((error) => {
                    console.error("Error updating cart note:", error);
                    $(".continue-checkout").removeClass("loading");
                  });
              })
              .catch((error) => {
                console.error("Error fetching cart:", error);
                $(".continue-checkout").removeClass("loading");
              });
          })
          .catch((error) => {
            console.error("Error adding item to cart:", error);
            $(".continue-checkout").removeClass("loading");
          });
      },
      error: function (XMLHttpRequest, textStatus) {},
    });
  });

  $(".close-modal").on("click", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "hidden")
      .css("opacity", "0");
    $("body").removeClass("modal-open"); // Enable scroll
  });
});

var swiper = new Swiper(".swiper-container-category", {
  slidesPerView: 2,
  spaceBetween: 10,
  freeMode: true,
  loop: true,
  simulateTouch: true,
  allowTouchMove: true,
  navigation: {
    nextEl: ".category-next",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    991: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 6,
    },
    1920: {
      slidesPerView: 7,
    },
  },
});

var swiper = new Swiper(".featured-related-products", {
  speed: 400,
  spaceBetween: 10,
  slidesPerView: 2,
  loop: true,
  navigation: {
    nextEl: ".featured-rel-prod-next",
    prevEl: ".featured-rel-prod-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.href.indexOf("/collections/new-products") !== -1) {
    const facetsWrapper = document.querySelectorAll(".facets-wrapper");
    if (facetsWrapper.length > 0) {
      facetsWrapper[0].style.display = "none";
    }
  }

  const cart = document.querySelector("cart-drawer");
  const options = {
    attributes: true,
  };

  function callback(mutationList, observer) {
    mutationList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        $("#CartDrawer-Note").val("");
      }
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(cart, options);

  const logoutTimeLimit = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  const loginTimeKey = "customerLoginTime";
  const lastLoginTime = localStorage.getItem(loginTimeKey);

  // If the customer is logged in and we have a recorded login time
  if (lastLoginTime) {
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - lastLoginTime;

    // If the time difference exceeds 24 hours, log them out
    if (timeDifference > logoutTimeLimit) {
      // Trigger logout (assuming Shopify handles customer logout via the URL)
      localStorage.removeItem("customerLoginTime");
      localStorage.removeItem("c_log");
      window.location.href = "/account/logout";
    }

    inactivityTime();
  }

});

var inactivityTime = function () {
  const timeLogin = "customerLoginTime";
  const c_log = "c_log";
  const lastLogin = localStorage.getItem(timeLogin);
  const customer = localStorage.getItem(c_log);
  var time;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer; // touchscreen presses
  window.ontouchstart = resetTimer;
  window.onclick = resetTimer; // touchpad clicks
  window.onkeydown = resetTimer; // onkeypress is deprectaed
  window.addEventListener("scroll", resetTimer, true); // improved; see comments

  function logout() {
    localStorage.removeItem("customerLoginTime");
    localStorage.removeItem("c_log");
    window.location.href =
      "https://ritemedqa.myshopify.com/account/logout/?return_url=/account/login";
  }

  function resetTimer() {
    if (customer) {
      if (lastLogin) {
        localStorage.setItem(timeLogin, new Date().getTime());
        
        clearTimeout(time);
        time = setTimeout(logout, 1800000);
        // 1000 milliseconds = 1 second
      }
    }
  }
};
